<template>
<div id="power-titulo">
    <v-card :class="
        tipo == 'admin'
          ? 'primary white--text titulocatalogo'
          : ' primary white--text titulomodal'
      ">
        <v-icon small class="white--text">{{ icon }}</v-icon>&nbsp;
        <span class="subheading">
            <strong>{{ title }}</strong>
        </span>
    </v-card>
</div>
</template>

<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: "Catalogo"
        },
        icon: {
            type: String,
            default: "library_books"
        },
        tipo: {
            type: String,
            default: "admin"
        }
    },
    computed: {},
    methods: {}
};
</script>
